/** funciones para el modulo de administracion de usuarios */
import axiosMailUpdate from '../services/axiosApi'
var adminUsers = {
    async getAllProfiles() {
        const response = await axiosMailUpdate.get('api/v1/profiles?sort_by=name')
        this.response = response.data.data
        return this.response
    },
    async getSpecificProfile(idProfile) {
        const response = await axiosMailUpdate.post('api/v1/profiles/' + idProfile)
        this.response = response.data.data
        return this.response
    },
    async addNewUser(dataUserNew) {
        const response = await axiosMailUpdate.post('api/v1/users', dataUserNew)
        this.response = response.data.data
        return this.response
    },
    async editUser(dataUserEdit) {
        let idUser = dataUserEdit.idUsers
        const response = await axiosMailUpdate.put('api/v1/users/' + idUser, dataUserEdit)
        this.response = response.data.data
        return this.response
    },
    async getAllUsers() {
        const response = await axiosMailUpdate.get('api/v1/users?sort_by=name')
        this.response = response.data.data
        return this.response
    },
    async getSpecificUser(idUserGet) {
        const response = await axiosMailUpdate.get('api/v1/users/' + idUserGet)
        this.response = response.data.data
        return this.response
    },
    async deleteUser(idUserDel) {
        const response = await axiosMailUpdate.delete('api/v1/users/' + idUserDel)
        //console.log(response)
        this.response = response.data.data
        return this.response
    }
}

export default adminUsers